import React, { FC } from 'react';
import { EditableComponent } from '@adobe/aem-react-editable-components';
import { OffersBenefitCardsProps } from './OffersBenefitCards.types';
import { StyledOffersBenefitCards } from './OffersBenefitCards.styles';
import { OffersBenefitCardsWrapper } from './OffersBenefitCardWrapper';

export const OffersBenefitCardsConfig = {
  emptyLabel: 'Offers Benefit Cards',
  isEmpty: () => true,
  resourceType: `mi-aem-offers-spa/components/offersbenefitcards`,
};

export const OfferBenefitswWrapper: React.FC<OffersBenefitCardsProps> = props => {
  return <OffersBenefitCardsWrapper {...props} />;
};

// Use named rather than default exports.
export const OffersBenefitCards: FC<OffersBenefitCardsProps> = props => {
  return (
    <EditableComponent config={OffersBenefitCardsConfig} {...props}>
      <StyledOffersBenefitCards data-testid="offers-benefitsCard" data-component-name="o-offers-BenefitsCard">
        <OfferBenefitswWrapper {...props} />
      </StyledOffersBenefitCards>
    </EditableComponent>
  );
};
